import React, {useState} from 'react';
import {StyleSheet} from 'react-native';
import {useFocusEffect} from '@react-navigation/native';

import {useWebScreenDimensions} from '../../hooks/useWebScreenDimensions';
import {AirtablePromotionItem} from '../../models/airtable';
import {AppRoute} from '../../models/AppRoute';
import useAppNavigation from '../../navigation/useAppNavigation';
import theme from '../../style/theme';

import BaseTile from './BaseTile';

const promotionStyle = StyleSheet.create({
  container: {
    marginHorizontal: 0,
  },
  touchable: {
    marginBottom: 8,
  },
  textHolder: {
    backgroundColor: theme.colour.background.feedTile.promotion,
    paddingHorizontal: 12,
    paddingVertical: 8,
  },
  headline: {
    marginTop: 4,
    marginBottom: 4,
  },
});

type PromotionTileProps = {
  promotion: AirtablePromotionItem;
};

const PromotionTile = ({promotion}: PromotionTileProps) => {
  const navigation = useAppNavigation();
  const {isWebDesktopScreen} = useWebScreenDimensions();

  // Used only in tiles on the Feed screen. Discover has too many
  // instances of videos playing that wrapping them in InViewPort
  // craps the UI thread on iOS. Easiest to just let them keep on
  // playing and not bother pausing them when they're out of view.
  const [paused, setPaused] = useState(true);
  useFocusEffect(
    React.useCallback(() => {
      // Do something when the screen is focused
      // component.current.startAutoplay(false);
      setPaused(false);

      return () => {
        // Do something when the screen is unfocused
        // Useful for cleanup functions
        // component.current.stopAutoplay();
        setPaused(true);
      };
    }, []),
  );

  const handlePromotionTilePress = () => {
    navigation.navigate(AppRoute.PROMOTION, {promotion});
  };

  return (
    <BaseTile
      item={promotion}
      customStyles={promotionStyle}
      pressCallback={handlePromotionTilePress}
      paused={paused}
      includeByline={true}
      isWebDesktopScreen={isWebDesktopScreen}
    />
  );
};

export default PromotionTile;
